module.exports = __webpack_public_path__ + "static/media/horse.ac9ff66b.png";